<template>
  <button 
    class="ui-lightbox-button" 
    :for="target"
    @click="$root.lightboxButtonClick($event, target), youtubeLoad(target, youtubeId)"
    :id="id"
    >
    <slot>
    </slot>
  </button>
</template>
<script>
import VueYoutube from '../../twig/vue/mixins/vue-youtube';

export default {
  props: ['target', 'youtubeId', 'id'],
  mixins: [VueYoutube]
};
</script>
